/* Right-side cart drawer helpers: close button + Escape key.
 * Open/close state itself belongs to theme.js (aria-hidden on #mini-cart,
 * toggled by the header cart control) — we only trigger that same control.
 */
(function () {
  'use strict';

  function closeDrawer() {
    var drawer = document.getElementById('mini-cart');
    if (!drawer || drawer.getAttribute('aria-hidden') !== 'false') return;
    var toggle = document.querySelector('.header__action-item--cart .header__action-item-link');
    if (toggle) toggle.click();
  }

  // Capture phase + stopPropagation: the drawer lives inside the header cart
  // toggle element, so a bubbling click on the X would hit the theme's own
  // toggle handler and immediately re-open the drawer.
  document.addEventListener('click', function (e) {
    if (e.target && e.target.closest && e.target.closest('[data-ha-drawer-close]')) {
      e.preventDefault();
      e.stopPropagation();
      closeDrawer();
    }
  }, true);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });
})();
